import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tag } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { SuppliersTable } from '@/components/suppliers/SuppliersTable'
import { InvoicesTable } from '@/components/suppliers/InvoicesTable'

export default function SuppliersPage() {
  useEffect(() => {
    document.title = 'Suppliers - Vixalor';
  }, []);
  const [activeTab, setActiveTab] = useState<'suppliers' | 'invoices'>('suppliers')
  const [supplierId, setSupplierId] = useState<string | null>(null)

  const handleSelectSupplier = (id: string) => {
    setSupplierId(id);
    setActiveTab('invoices');
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Supplier Management</h1>
        <p className="text-muted-foreground mt-1">
          Manage your suppliers, invoices and payments.
        </p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <Tag className="h-5 w-5 text-primary" />
            <CardTitle>Suppliers</CardTitle>
          </div>
          <CardDescription>Manage your supplier relationships</CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={val => setActiveTab(val as any)} className="w-full">
            <TabsList className="mb-4">
              <TabsTrigger value="suppliers">Suppliers</TabsTrigger>
              <TabsTrigger value="invoices">Invoices</TabsTrigger>
            </TabsList>
            <TabsContent value="suppliers">
              <SuppliersTable onSelect={handleSelectSupplier} />
            </TabsContent>
            <TabsContent value="invoices">
              <InvoicesTable supplierId={supplierId} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  )
}
